// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import EyeInvisibleOutlinedSvg from "@ant-design/icons-svg/lib/asn/EyeInvisibleOutlined";
import AntdIcon from "../components/AntdIcon";
const EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: EyeInvisibleOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    EyeInvisibleOutlined.displayName = "EyeInvisibleOutlined";
}
export default /*#__PURE__*/ React.forwardRef(EyeInvisibleOutlined);
